
import {createFilter} from '../basic';
export let createGrouper =(baseFunc, groupFunc) => {

  let func = null;

  let setBase = base => {
    let baseColor = baseFunc(...base);
    func = createFilter((r,g,b) =>groupFunc(baseColor,r,g,b))
  }
  let execute = data =>func(data);

  return {execute, setBase}
}
